import TicketUpdateView from '../../components/TicketUpdateView'
import { Breadcrumbs, Grid, Link, Typography } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TitlebarAction from '../../components/common/TitlebarActions'
import TopSideBar from '../../components/TopSideBar'
import PageContainer from '../../components/common/PageContainer'
import { useParams } from 'react-router-dom'
import Copyright from '../../components/common/Copyright'
import { useProject } from '../../context/ProjectContext'
import { useEffect } from 'react'

export default function TicketUpdateViewPage({ setBlockScreen }: any) {
  const { ticket_number, update_number, project_code } = useParams()
  const { selectedProject, setSelectedProject } = useProject()

  useEffect(() => {
    if (project_code) {
      setSelectedProject(project_code)
    }
  }, [project_code])

  return (<>
    <TopSideBar currentSection='tickets' disableProjectSelector />

    <PageContainer>

      <Grid paddingBottom={PADDING_BASE}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Home
          </Link>
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Tickets
          </Link>
          <Typography fontFamily='Poppins' color="darkgreen">
            Actualización
          </Typography>
          <Typography color="darkgreen" fontWeight={"bold"}>
            Detalle
          </Typography>
        </Breadcrumbs>
      </Grid>

      <TitlebarAction
        title={`Actualización #${update_number} - #${ticket_number}`}
      >

      </TitlebarAction>

      {selectedProject === project_code && (
        <TicketUpdateView
          ticket_number={ticket_number}
          update_number={update_number}
          setBlockScreen={setBlockScreen}
        />)}

      <Copyright />

    </PageContainer>
  </>)
}